import React from 'react'

const ErrorCallback = ({ error, resetErrorBoundary }) => {
  return (
    <div>
      새로고침을 해주시거나 잠시 뒤에 접속해주세요.
    </div>
  );
};

export default ErrorCallback